import { platform } from 'utils/constants'

export const computeMenuOptions = (isOwner: boolean, isWorkout: boolean) => {
  if (isOwner) {
    if (!platform.IS_WEB) {
      if (isWorkout) {
        return ['Edit', 'Duplicate', 'Delete', 'Copy Post Link']
      }

      return ['Delete']
    }

    if (isWorkout) {
      return ['Edit', 'Duplicate', 'Delete']
    }

    return ['Delete']
  }

  if (!platform.IS_WEB) {
    return ['Report Post', 'Copy Post Link']
  }

  return ['Report Post']
}
